import { render, staticRenderFns } from "./ppnkeluaran.vue?vue&type=template&id=53603f3a"
import script from "./ppnkeluaran.vue?vue&type=script&lang=js"
export * from "./ppnkeluaran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports